import { render, staticRenderFns } from "./ChartWrap.vue?vue&type=template&id=132a3dc0&scoped=true"
import script from "./ChartWrap.vue?vue&type=script&lang=js"
export * from "./ChartWrap.vue?vue&type=script&lang=js"
import style0 from "./ChartWrap.vue?vue&type=style&index=0&id=132a3dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a3dc0",
  null
  
)

export default component.exports